/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VIDEO_CONTENT_EXTRA_BUTTONS',
  PUT: 'UPDATE_VIDEO_CONTENT_EXTRA_BUTTONS',
  DELETE: 'DELETE_VIDEO_CONTENT_EXTRA_BUTTONS',
  RESET: 'RESET_VIDEO_CONTENT_EXTA_BUTTONS',
};


export const getDraftId = () => (`videoContentMainPanelExtraButtons-draft${new Date().valueOf()}`);

export const videoContentMainPanelExtraButtonsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        { ...action.payload, id: getDraftId() },
      ];
    case types.PUT:
      return action.payload;
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
